import React, { useState, useEffect } from "react";
import { BsFillGrid3X3GapFill } from "react-icons/bs";

import { FaRegUser } from "react-icons/fa";
import { getTotalUser, getTotalPlaces } from "../services/web/webServices";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalPlacesCount, setTotalPlacesCount] = useState("");

  useEffect(() => {
    getTotalUser()
      .then((res) => {
        setTotalUserCount(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getTotalPlaces()
      .then((res) => {
        setTotalPlacesCount(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <>
      <main className="main-container">
        <div className="main-title">
          <h3
            style={{
              fontSize: "44px", // Set font size
              fontWeight: "bold", // Make the text bold
              color: "#263043", // Set text color (white for contrast)
              // paddingLeft:"20px"
              padding: "20px",
            }}
          >
            Welcome To Dashboard
          </h3>
        </div>

        <div className="main-cards">
          <div className="card" onClick={() => navigate("/userManagement")}>
            <div className="card-inner">
              <h3>TOTAL USERS</h3>
              <FaRegUser className="card_icon" />
            </div>
            <h1>{totalUserCount.user}</h1>
          </div>
          <div className="card" onClick={() => navigate("/placesManagement")}>
            <div className="card-inner">
              <h3>PLACES</h3>
              <BsFillGrid3X3GapFill className="card_icon" />
            </div>
            <h1>{totalPlacesCount}</h1>
          </div>
          {/* <div className="card">
            <div className="card-inner">
              <h3>CUSTOMERS</h3>
              <BsPeopleFill className="card_icon" />
            </div>
            <h1>33</h1>
          </div> */}
          {/* <div className="card">
            <div className="card-inner">
              <h3>ALERTS</h3>
              <BsFillBellFill className="card_icon" />
            </div>
            <h1>42</h1>
          </div> */}
        </div>
      </main>
    </>
  );
}

export default Home;
